<template>
  <data-manager-layout>
    <el-button
      v-if="!readonly"
      slot="actions"
      type="primary"
      icon="el-icon-circle-plus"
      @click="addRow"
    >
      {{ $t('DataManager_Button_CreateEvent') }}
    </el-button>
    <router-link slot="actions" :to="importRoute" v-if="!readonly">
      <el-button type="primary" icon="el-icon-upload">
        {{ $t('DataManager_Events_Import_Button') }}
      </el-button>
    </router-link>

    <rest-list-editable
      :payload="fetchEndpoint"
      :add-endpoint="rowAddEndpoint"
      :update-endpoint="rowUpdateEndpoint"
      :rules="rules"
      ref="rest-list"
    >
      <rest-list-column
        prop="title"
        :title="$t('DataManager_Events_Field_Name')"
        :editable="true"
      >
        <template slot="input-edit" slot-scope="{ model }">
          <el-input
            :placeholder="$t('DataManager_Events_Field_Name')"
            v-model="model.title"
          />
        </template>
      </rest-list-column>

      <rest-list-column-boolean
        prop="store_event_hit"
        :title="$t('DataManager_Events_Field_StoreEventHit')"
        :editable="true"
        :tooltip-text="$t('DataManager_Events_Field_StoreEventHit_Description')"
      ></rest-list-column-boolean>

      <rest-list-column-boolean
        prop="process_event_hit"
        v-if="$isSuperAdmin()"
        :title="$t('DataManager_Events_Field_ProcessEventHit')"
        :editable="true"
      />

      <rest-list-column-actions v-if="!readonly" :editable="true">
        <template slot-scope="scope">
          <rest-list-action-delete
            :endpoint="rowDeleteEndpoint(scope.row)"
            :name="scope.row.title"
          />
          <rest-list-action-delete
            :endpoint="eventDataDeleteEndpoint(scope.row)"
            :name="scope.row.title"
            title="RestList_Action_Delete_Events_Data"
            :delete-message="
              $t('RestList_Data_Event_DeletePrompt', { label: scope.row.title })
            "
          />
        </template>
      </rest-list-column-actions>
    </rest-list-editable>
  </data-manager-layout>
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean'
import DataManagerLayout from '@/modules/data-manager/pages/DataManagerLayout'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListEditable from '@/common/components/rest/RestListEditable'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'

export default {
  name: 'DataManagerEventsPage',

  components: {
    RestListActionDelete,
    RestListColumnActions,
    RestListEditable,
    DataManagerLayout,
    RestListColumn,
    RestListColumnBoolean
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `events`,
        params: {
          sort: 'title'
        }
      })
    },

    rowAddEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `events`
      })
    },

    importRoute() {
      return projectRoute({
        name: 'ImportCreate',
        params: { type: 'events' }
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    },
    rules() {
      return {
        title: { required: true }
      }
    }
  },

  methods: {
    addRow() {
      const model = {
        id: '',
        type: 'custom',
        title: '',
        store_event_hit: 1,
        process_event_hit: 1
      }
      this.$refs['rest-list'].addRow(model)
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `events/${row.id}`
      })
    },

    eventDataDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `events/${row.id}/delete-event-data`
      })
    },

    rowUpdateEndpoint(row) {
      return projectEndpoint({
        method: 'patch',
        url: `events/${row.id}`
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/data-manager/pages/DataManagerEventsPage.vue